import type { PlanFeatureLimit } from '@/services/auth/types';
import { isEmptyOrEmptyObject } from './objects';

export const getLimitValue = (feature: PlanFeatureLimit | Record<string, never> | undefined) => {
  // if the feature is an empty object it means there are no limits for this feature
  if (!isEmptyOrEmptyObject(feature)) {
    const featureLimits = feature as PlanFeatureLimit;
    return featureLimits.limit;
  }
  return false;
};

// Re-export plan feature access utilities from services/auth
export { hasUnlimitedPlanFeatureAccess } from '@/services/auth/plan-features';
